import type { VoidFunctionComponent } from 'react';

import DetailsPanel, { DetailsPanelLink } from '../../../generic/DetailsPanel';

import DrawerSection from './Section';

import styles from './VulnerabilitiesDrawer.module.less';

/**
 * Check whether or not a string is a valid web URL.
 * Based on https://stackoverflow.com/a/43467144.
 * @param value String to check
 * @returns True if a valid URL, otherwise false
 */
const isValidWebURL = (value: string): boolean => {
  let url: URL;
  try {
    url = new URL(value);
  } catch {
    return false;
  }

  return ['http:', 'https:'].includes(url.protocol);
};

//  We don't need to show the full URL, just the hostname will suffice.
const getURLHostname = (url: string) =>
  (new URL(url))?.hostname || url;

type Props = {
  references: string[];
};

/**
 * VulnerabilityDrawerReferences renders a DetailsPanel
 * with a list of links referencing where FOSSA has discovered this vuln.
 */
const VulnerabilityDrawerReferences: VoidFunctionComponent<Props> = ({ references }) => {
  const validReferences = references.filter(isValidWebURL);
  return (
    <DrawerSection>
      <DetailsPanel
        id="package-vulns-drawer-details"
        target="References"
        targetCount={validReferences.length}
      >
        {validReferences.length ? validReferences.map(reference => (
          <div key={reference} className="margin-bottom-xs">
            <DetailsPanelLink to={reference}>
              {getURLHostname(reference)}
            </DetailsPanelLink>
          </div>
        )) : (
          <div className={styles.emptySectionText}>No references</div>
        )}
      </DetailsPanel>
    </DrawerSection>
  );
};

export default VulnerabilityDrawerReferences;
